import { GET_WORD_VAULT, GET_CATEGORIES, CREATE_WORD, GET_WORD_DETAILS } from '../../types'

const initialState = {
  wordVault: {},
  categories: [],
  wordDetails: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_WORD_VAULT: return {
      ...state,
      wordVault: action.payload
    }
    case GET_CATEGORIES: return {
      ...state,
      categories: action.payload
    }
    case CREATE_WORD: return {
      ...state
    }
    case GET_WORD_DETAILS: return {
      ...state,
      wordDetails: action.payload
    }
    default: return { ...state }
  }
}
